import {useState} from 'react';
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import Alert from "../../../alert/Alert";
import Field from "../../Field"
import Loading from "../../../generic/Loading";

import {InfoLabel, SettingsLabel, SingleShootLabel} from "../../../../config/Config";


const SingleShoot = (props) => {
    const {journey, currentNode} = props
    const [loading, setLoading] = useState(false)


    const Information = {
        className: 'alert-primary',
        message: `As its name suggests, this input component is executed only once. `,
        docs: {
            message: 'For more info you can ',
            path: '/docs/journeys/single-shoot/'
        }
    }


    const Id = {
        tab         : 'info',
        name        : 'id',
        type        : 'text',
        label       : 'Component Id',
        wrapper     : 'form-group',
        disabled    : true,
        canCopy     : true,
        defaultValue: currentNode.id,
        node        : currentNode,
    }

    const Title = {
        tab         : 'info',
        name        : 'title',
        type        : 'text',
        label       : 'Title',
        wrapper     : 'form-group',
        placeholder : 'Type an descriptive title',
        node        : currentNode,
        defaultValue: SingleShootLabel,
    }


    const Description = {
        tab        : 'info',
        name       : 'description',
        type       : 'textarea',
        label      : 'Description',
        wrapper    : 'form-group',
        className  : 'form-control',
        placeholder: 'Type a short description',
        node       : currentNode,
    }


    const StartDate = {
        tab        : 'settings',
        name       : 'start_date',
        type       : 'datetime-local',
        label      : 'Start date',
        wrapper    : 'form-group',
        required   : true,
        placeholder: 'Choose start date',
        node       : currentNode,
    }


    const ExpireDate = {
        tab        : 'settings',
        name       : 'end_date',
        type       : 'datetime-local',
        label      : 'Expire date',
        wrapper    : 'form-group',
        required   : true,
        placeholder: 'Choose expire date',
        node       : currentNode,
    }


    return (
        <div>
            {loading && <Loading />}
            {!loading && <div className="Form">
                <form className="FormComponent">
                    <div className="max-width-500">
                        <Alert {...Information} />

                        <div className="FieldsetTabs">
                            <Tabs defaultActiveKey="0">
                                <TabPane forceRender={true} key={'tab_settings'} tabKey={'tab_settings'} tab={SettingsLabel}>
                                    <div>
                                        <Field {...StartDate} />
                                        <Field {...ExpireDate} />
                                    </div>
                                </TabPane>
                                <TabPane forceRender={true} key={'tab_info'} tabKey={'tab_info'} tab={InfoLabel}>
                                    <div>
                                        <Field {...Id}/>
                                        <Field {...Title}/>
                                        <Field {...Description}/>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </form>
            </div>}
        </div>
    )
}

export default SingleShoot;